// extracted by mini-css-extract-plugin
export var box = "Checkbox-module--box--9fef1";
export var box_md = "Checkbox-module--box_md--eaecf";
export var box_xmd = "Checkbox-module--box_xmd--69510";
export var box_flex = "Checkbox-module--box_flex--09b42";
export var box_lg = "Checkbox-module--box_lg--ff274";
export var box_sm = "Checkbox-module--box_sm--f3d38";
export var box_outer = "Checkbox-module--box_outer--79b4e";
export var box_whiteBg = "Checkbox-module--box_white-bg--a51ba";
export var box_noMarginBottom = "Checkbox-module--box_no-margin-bottom--f0413";
export var box_noPadding = "Checkbox-module--box_no-padding--53c2b";
export var box_outerGray = "Checkbox-module--box_outer-gray--c642b";
export var box_dark = "Checkbox-module--box_dark--10c07";
export var box_zIndex = "Checkbox-module--box_z-index--d01a9";
export var box_zIndex6 = "Checkbox-module--box_z-index-6--f51e3";
export var box_eventsWithLine = "Checkbox-module--box_events-with-line--fc2ef";
export var box_featuresAo = "Checkbox-module--box_features-ao--d5efa";
export var box_verticalPaddings = "Checkbox-module--box_vertical-paddings--43615";
export var clearP = "Checkbox-module--clearP--bc56d";
export var clearP_vc = "Checkbox-module--clearP_vc--ac7e8";
export var checkbox = "Checkbox-module--checkbox--abbf1";
export var square = "Checkbox-module--square--151f9";
export var content = "Checkbox-module--content--f8dcf";
export var input = "Checkbox-module--input--20727";
export var fadeInAnimation = "Checkbox-module--fadeInAnimation--abd28";
export var placeHolderShimmer = "Checkbox-module--placeHolderShimmer--950d8";